import { render, staticRenderFns } from "./user-name.vue?vue&type=template&id=4b12e573"
import script from "./user-name.vue?vue&type=script&lang=js"
export * from "./user-name.vue?vue&type=script&lang=js"
import style0 from "./user-name.vue?vue&type=style&index=0&id=4b12e573&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports